module.exports = __webpack_public_path__ + "img/app_apple.95c151be.png";